import ApiShareLink from '@/api/apiShareLink.v2';
// import api from '@/api/api';
import baseUrl from  "@/api/baseApi"
import Api from '@/api/api'
// import data from "@/temp/geofence.json";

export default {
    createShareLink(body) {
        // return ApiShareLink.post(`/api/ShareLink/CreateLink`, body);
        return ApiShareLink.post(`/sharelink/CreateLink`, body);
    },
    saveGeofencingData(geoJson) {
        console.error('Not Implemented : ', geoJson);
    },
    fetchGeofencingData(key) {
        return baseUrl.get(`/geofence/api/Geofence/GetGeofences?ChannelKey=${key}`);
    },
    createGeofence(body) {
        return baseUrl.post(`/geofence/api/Geofence/CreateGeofence`, body);
    },
    removeGeofence(id) {
        return baseUrl.delete(`/geofence/api/Geofence/RemoveGeofence/${id}`);
    },
    updateGeofence(body) {
        return baseUrl.put(`/geofence/api/Geofence/UpdateGeofence`, body);
    },
    addVehiclesToGeofence(body) {
        return baseUrl.put(`/geofence/api/Geofence/MapDevicesToGeofence`, body);
    },
    removeVehicleFromGeofence(data) {
        return baseUrl.put(`/geofence/api/Geofence/DemapDevicesFromGeofence`,data);
    },

    //Get Geofence count in dashboard
     
    getGeofenceCount(channelKey) {
        return baseUrl.get(`geofence/api/Geofence/getGeofenceInAndOutCount?ChannelKey=${channelKey}`);
    },
    immbolizeVehicle(body){
        return Api.post(`api/IOTCommand/InvokeIOTCommand`,body)
    }

}